import classNames from 'classnames';
import { useSharedState } from '@trello/shared-state';
import React, { useCallback } from 'react';
import { forTemplate } from '@trello/i18n';
import styles from './HeaderLogo.less';
import { RouterLink } from 'app/src/components/RouterLink';
import { navigationState } from './navigationState';
import { forwardRefComponent } from 'app/src/forwardRefComponent';
import { Analytics, getScreenFromUrl } from '@trello/atlassian-analytics';

const format = forTemplate('header_back_menu_button');

interface Props {
  className?: string;

  // Set to true if we want to full page pop the redirect to '/', which
  // we do in the anonymous header so it takes us to the meta page.
  skipRouter?: boolean;

  isLeftAligned?: boolean;
  anonymous?: boolean;
}

export const HeaderLogo = forwardRefComponent<HTMLAnchorElement, Props>(
  'HeaderLogo',
  ({ className, isLeftAligned, skipRouter, anonymous }, ref) => {
    const [{ isNavigating }] = useSharedState(navigationState);

    const classes = classNames(
      styles.anonymousLogo,
      className,
      !anonymous && styles.logo,
      isLeftAligned && styles.narrowScreen,
    );

    const onClickHeaderLogo = useCallback(() => {
      Analytics.sendClickedLinkEvent({
        linkName: 'headerLogo',
        source: getScreenFromUrl(),
      });
    }, []);

    const logo = (
      <>
        <div className={styles.logoContainer}>
          <div className={styles.newLogo} data-loading={isNavigating} />
        </div>
      </>
    );

    return skipRouter ? (
      <a
        href="/"
        onClick={onClickHeaderLogo}
        className={classes}
        aria-label={format('backToHome')}
      >
        {logo}
      </a>
    ) : (
      <RouterLink
        href="/"
        className={classes}
        onClick={onClickHeaderLogo}
        aria-label={format('backToHome')}
        ref={ref}
      >
        {logo}
      </RouterLink>
    );
  },
);
